// Real-internet probe.
//
// navigator.onLine is NOT a real-internet signal on a pilot's iPad:
//   - PPU wifi is a navigation link from the ship's AIS to the iPad (wifi, not
//     bluetooth, for a stronger connection). It carries AIS nav data and goes
//     NOWHERE — there is no internet on PPU wifi, ever. navigator.onLine is
//     still TRUE.
//   - Ship's wifi IS a satellite internet connection (real, though it can be
//     slow or drop while still showing "connected").
// So navigator.onLine === true means "attached to some network," not "can
// reach the internet." Only an actual round-trip can tell them apart.
//
// This pings Supabase's health endpoint (needs real internet) behind a hard
// AbortController deadline so it can never itself hang on dead/PPU wifi (old
// iPads lack AbortSignal.timeout, hence the manual fallback). Returns true
// ONLY on a real 2xx response. Mirrors the AuthContext health check.
export async function probeInternet(timeoutMs = 4000) {
  // The browser being certain it's offline is trustworthy on its own; skip the
  // round-trip. (The reverse — onLine true — proves nothing, so we still ping.)
  if (typeof navigator !== "undefined" && navigator.onLine === false) return false;

  const url = import.meta.env.VITE_SUPABASE_URL;
  const key = import.meta.env.VITE_SUPABASE_ANON_KEY;
  if (!url) return false;

  let signal;
  let timer;
  if (typeof AbortSignal !== "undefined" && AbortSignal.timeout) {
    signal = AbortSignal.timeout(timeoutMs);
  } else if (typeof AbortController !== "undefined") {
    const c = new AbortController();
    timer = setTimeout(() => c.abort(), timeoutMs);
    signal = c.signal;
  }

  try {
    const res = await fetch(`${url}/auth/v1/health`, {
      method: "GET",
      cache: "no-store",
      headers: key ? { apikey: key } : {},
      ...(signal ? { signal } : {}),
    });
    return res.ok;
  } catch {
    return false;
  } finally {
    if (timer) clearTimeout(timer);
  }
}
